import {createReducer} from "redux-act";
import {fetchRidersJSONSuccess} from "modules/actions";
import {ISquad} from "modules/types";
import {RiderStatusType} from "modules/utils";

export interface IRiderStatsEvent {
	points: number;
	fastest_lap: number;
	final_points: number;
	grid_points: number;
	grid_position: number;
	qualifying_position: number;
	qualifying_vs_final_position: number;
	qualifying_vs_final_position_points: number;
	race_time: string;
	race_time_float: string;
	q1_position: number;
	q1_points: number;
	q2_points: number;
	q2_position: number;
	final_position: number | null;
	sprint_position: number;
	sprint_points: string;
}

export interface IRiderStats {
	wpr: number;
	prices: Record<string, number>;
	total_points: number;
	avg_points: number;
	events: Record<string, IRiderStatsEvent>;
	podium: number;
	race_time: number;
	last_event: number;
	last_3_events: number;
	last_5_events: number;
	season_points: number;
	starts: number;
	avg_qualifying_pos: number;
	avg_grid_pos: number;
	avg_finishing_pos: number;
	cost: number;
	price_diff: number;
}

export interface IRider {
	id: number;
	constructor_id: number;
	squad_id: number;
	squad?: ISquad;
	first_name: string;
	last_name: string;
	cost: number;
	stats: IRiderStats;
	country: string;
	number: number;
	status: RiderStatusType;
	is_in_team?: boolean;
}

const defaultState: IRider[] = [];

export const riders = createReducer<typeof defaultState>({}, defaultState).on(
	fetchRidersJSONSuccess,
	(_state, payload) => payload
);
